export const buildFilesList = files => {
  if (files.length) {
    return files.map(file => {
      return {
        action: {
          name: file.filename,
          value: file.base64_content
        },
        name: "downloadPDF",
        title: file.filename,
        type: "text",
        textColor: "green",
        params: "TDFieldOptionAutoCorrectNone"
      };
    });
  }
};
